import { render } from "./SendTable.vue?vue&type=template&id=5cb63c56&scoped=true"
import script from "./SendTable.vue?vue&type=script&lang=ts"
export * from "./SendTable.vue?vue&type=script&lang=ts"

import "./SendTable.vue?vue&type=style&index=0&id=5cb63c56&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5cb63c56"

export default script